if (!customElements.get('product-collapsible-tab')) {
  customElements.define('product-collapsible-tab', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.summary.nextElementSibling;
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.animation) return;
        this.setOpen(!this.details.open);
      });
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      });
      this.addEventListener('shopify:block:select', () => this.setOpen(true));
      this.addEventListener('shopify:block:deselect', () => this.setOpen(false));
    }

    setOpen(open) {
      this.animation?.cancel();
      this.animation = null;
      if (open === this.details.open) return;
      this.summary.setAttribute('aria-expanded', String(open));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !this.content.animate) {
        this.details.open = open;
        return;
      }
      this.details.open = true;
      const expanded = { height: `${this.content.offsetHeight}px`, marginTop: '-5px', paddingBottom: '25px' };
      const collapsed = { height: '0px', marginTop: '0px', paddingBottom: '0px' };
      this.content.style.overflow = 'hidden';
      this.animation = this.content.animate(open ? [collapsed, expanded] : [expanded, collapsed], {
        duration: 200,
        easing: 'linear',
      });
      this.animation.onfinish = () => {
        this.details.open = open;
        this.summary.setAttribute('aria-expanded', String(open));
        this.content.style.removeProperty('overflow');
        this.animation = null;
      };
      this.animation.oncancel = () => this.content.style.removeProperty('overflow');
    }

    disconnectedCallback() {
      this.animation?.cancel();
      this.animation = null;
    }
  });
}
